import * as Yup from "yup";
import { InputIssue, InputRules, finalizeInput, inputIssue } from "./secureInput";

// Whitelist patterns: block HTML tags, script, quotes and SQL meta-characters.
export const PATTERNS = {
  code: /^[A-Za-z0-9]+$/,
  username: /^[A-Za-z0-9_]+$/,
  name: /^[A-Za-z]+(?:[\s'.-][A-Za-z]+)*$/,
  phone: /^\+?\d{8,15}$/,
  password: /^[A-Za-z0-9!@#$%^&*()_+=.?-]+$/,
  remarks: /^[A-Za-z0-9\s.,-]*$/,
};

export const MESSAGES = {
  code: "Only letters and numbers are allowed",
  username: "Only letters, numbers and underscore are allowed",
  name: "Only letters, spaces and ' . - are allowed",
  phone: "Please enter a valid phone number",
  password: "Only letters, numbers and !@#$%^&*()_+=.?- are allowed",
  remarks: "Only letters, numbers, spaces and . , - are allowed",
};

export const NAME_CHARS = /[^A-Za-z\s'.-]/g;

export type Translate = (key: string, options?: Record<string, unknown>) => string;

const ISSUE_KEYS: Record<InputIssue, string> = {
  required: "validation_input_required",
  control: "validation_input_control",
  markup: "validation_input_markup",
  tooLong: "validation_input_too_long",
  tooShort: "validation_input_too_short",
  email: "validation_email_format",
  number: "validation_input_number",
};

export const issueMessage = (t: Translate, issue: InputIssue, rules: InputRules) =>
  t(ISSUE_KEYS[issue], { min: rules.minLength, max: rules.maxLength });

/**
 * The start of every text field's schema. Submits the finalised value (NFKC,
 * trimmed) and rejects control characters, markup and over-long input before
 * any field-specific rule runs. Chain required/min/matches after it as usual.
 */
export const secureString = (t: Translate, rules: InputRules = {}) =>
  Yup.string()
    .transform((value) => finalizeInput(value, rules.kind))
    .test("secure-input", "", function (value) {
      const issue = inputIssue(value, rules);
      return issue ? this.createError({ message: issueMessage(t, issue, rules) }) : true;
    });
